module.exports = __webpack_public_path__ + "static/media/serv_construction.a86712cb.png";